'use strict';

define('cookie',['jquery', 'cookie-plugin'], function ($, Cookie) {

  var Cookie = jsCookies;

  var IS_VISIBLE = 'is-visible',
      IS_HIDDEN = 'is-hidden';

  var module = {},
      $cookieContainer,
      $closeButton,
      $acceptButton,
      cookieName = 'cookie-policy',

      closePopup = function () {
        $cookieContainer.addClass(IS_HIDDEN);
      },

      closeAndSaveState = function() {
        closePopup();
        Cookie.set(cookieName, 1, 365, '/')
      };


  var attachEvents = function() {
    $closeButton.on('click', function() {
      closePopup();
    });

    $acceptButton.on('click', function() {
      closeAndSaveState();
    });
  };

  module.init = function () {
    $cookieContainer = $('.js-cookie-container');
    $closeButton = $cookieContainer.find('.js-cookie-close');
    $acceptButton = $cookieContainer.find('.js-cookie-accept');
    attachEvents();

    if(!Cookie.check(cookieName)) {
      $cookieContainer.addClass(IS_VISIBLE);
    }
  };

  return module;

});

